import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle, } from "@/components/ui/card"
import { useForm } from "@inertiajs/react"
import { FormEvent } from "react"
import { t } from "@/lib/i18n"
export function PasswordForm() {
    const { data, setData, patch, processing, errors, reset } = useForm({
        current_password: "",
        password: "",
        password_confirmation: "",
    })
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        patch("/profile/password", {
            onSuccess: () => reset(),
            onError: () => reset("current_password", "password", "password_confirmation"),
        })
    }
    const handleCancel = () => {
        window.history.back()
    }
    return (<Card variant="borderless">
      <CardHeader>
        <CardTitle>{t("ui.react.components.features.profiles.password_form.change_password")}</CardTitle>
        <CardDescription>{t("ui.react.components.features.profiles.password_form.enter_password_current_new")}</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-6" data-testid="password-edit-form">
          <div className="space-y-2">
            <Label htmlFor="current_password">{t("ui.react.components.features.profiles.password_form.password_current")}</Label>
            <Input id="current_password" type="password" value={data.current_password} onChange={(e) => setData("current_password", e.target.value)} required/>
            {errors.current_password && (<p className="text-sm text-destructive">{errors.current_password}</p>)}
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">{t("ui.react.components.features.profiles.password_form.new_password")}</Label>
            <Input id="password" type="password" value={data.password} onChange={(e) => setData("password", e.target.value)} required/>
            {errors.password && (<p className="text-sm text-destructive">{errors.password}</p>)}
          </div>
          <div className="space-y-2">
            <Label htmlFor="password_confirmation">{t("ui.react.components.features.profiles.password_form.confirm_password")}</Label>
            <Input id="password_confirmation" type="password" value={data.password_confirmation} onChange={(e) => setData("password_confirmation", e.target.value)} required/>
            {errors.password_confirmation && (<p className="text-sm text-destructive">{errors.password_confirmation}</p>)}
          </div>
          <div className="flex items-center gap-3">
            <Button type="submit" disabled={processing} data-testid="update-password-button">{t("ui.react.components.features.profiles.password_form.change_password")}</Button>
            <Button type="button" variant="ghost" onClick={handleCancel}>{t("ui.react.components.features.profiles.password_form.cancel")}</Button>
          </div>
        </form>
      </CardContent>
    </Card>)
}
